// removed by extract-text-webpack-plugin
module.exports = {"popupBody":"PopupSale__popupBody___PJIh8","popupMainDiv":"PopupSale__popupMainDiv___1wFnF","questionHolder":"PopupSale__questionHolder___3YOeh","addIconElement":"PopupSale__addIconElement___28tfR","addIconImage":"PopupSale__addIconImage___iTIKl","policyHeading":"PopupSale__policyHeading___-o5g_","bodySubElements":"PopupSale__bodySubElements___3iR6q","saveDiv":"PopupSale__saveDiv___MSbdm","saveSpan":"PopupSale__saveSpan___gkXoc","alertDialog":"PopupSale__alertDialog___6JRwn","dialog":"PopupSale__dialog___3OVXq","button":"PopupSale__button___1vCBs"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PopupSale/PopupSale.css
// module id = 1023
// module chunks = 0